import { render, staticRenderFns } from "./infoForm.vue?vue&type=template&id=b6e57d4a&scoped=true&"
import script from "./infoForm.vue?vue&type=script&lang=js&"
export * from "./infoForm.vue?vue&type=script&lang=js&"
import style0 from "./infoForm.vue?vue&type=style&index=0&id=b6e57d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e57d4a",
  null
  
)

export default component.exports